import React, { Fragment } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import theme, { textStyles as ts } from '../../theme';
import { PrimaryButton } from '../Button';
import Spacer from '../Spacer';

let autoSearchCall = true;

const ErrorText = styled.p`
  ${ts.body};
  color: ${theme('colors.destructive')};
`;

const Input = styled.input`
  ${ts.textFieldValue};
  ${theme('colors.destructive').apply((col, { hasError }) => (hasError
    ? `
      border: 1px solid;
      border-color: ${col};
      color: ${col};
      `
    : ''
  ))}
  flex-grow: 1;
  height: ${theme('size.button')};
  box-sizing: border-box;
  padding: 0px ${theme('spacing.regular')};
  min-width: 0;
  border-radius: ${theme('radius.regular')};
  ${({ hasButton }) => (hasButton
    ? `border-bottom-right-radius:0px;
      border-top-right-radius:0px;
      border-right-color: transparent !important;`
    : '')} 
  &:focus ~ button {
    border-left: 0 none !important;
    border-left-color: ${theme('colors.accentTertiary')} !important;
  }
  &:focus, &:focus ~ button {
    outline: 0 none;
    border: 1px solid ${theme('colors.divider')}; 
  }

  &::placeholder {
    ${ts.bodyPlaceholder};
  }

  background: ${theme('colors.backgroundVeryDark')};
  transition: border 0.1s linear;
`;

const Label = styled.label`
  display: flex;
  flex-flow: row nowrap;
  position: relative;
  margin: 1px;
  
`;

const Button = styled(PrimaryButton)`    
  margin-left: -1px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  box-shadow: none;
  @media (max-width: ${theme('layout.pageWidth')}) {
    max-width: ${theme('size.inputButtonMobileMaxWidth')};
  }
`;

const TextFieldComponent = ({ value, placeholder, error, actionText,
  actionFormAction, onChange, onFocus, onAction, inputType, autoChangeCall, ...props }) => (
    <Fragment>
      <Label>
        {/*
          When the onChange callback is not defined, nothing is listening
          for changes and therefore the value will never be updated.
          Therefore, the input should become uncontrolled so it will work
          even when JS is enabled.
          https://reactjs.org/docs/uncontrolled-components.html#default-values
        */}
        <Input
          value={onChange ? undefined : value}
          defaultValue={onChange ? value : undefined}
          type={inputType}
          placeholder={placeholder}
          hasButton={actionText !== null}
          hasError={Boolean(error)}
          onFocus={onFocus}
          onChange={onChange ? e => onChange(e.target.value) : undefined}
          {...props}
        />
        {(()=>{
          if(autoSearchCall && value && autoChangeCall) { onChange(value); }
          autoSearchCall=false; 
        })()}
        {actionText
          ? (
            <Button
              title={actionText}
              onClick={onAction}
              formAction={actionFormAction}
              dynamicWidth
            />
          )
          : null}
      </Label>
      { error && error.length
        ? (
          <Fragment>
            <Spacer size="small" />
            <ErrorText>{error}</ErrorText>
          </Fragment>
        )
        : null }
    </Fragment>
);

TextFieldComponent.propTypes = {
  value: PropTypes.string,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  actionText: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onAction: PropTypes.func,
  actionFormAction: PropTypes.string,
  inputType: PropTypes.string,
  autoChangeCall: PropTypes.bool
};

TextFieldComponent.defaultProps = {
  value: '',
  error: null,
  placeholder: '',
  actionText: null,
  onChange: () => {},
  onFocus: () => {},
  onAction: () => {},
  actionFormAction: null,
  inputType: "text",
  autoChangeCall: false
};

export default TextFieldComponent;
